import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectModels() {
      return getState().projectModels;
    },
    isRetrieveProjectModelsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveProjectModelsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveProjectModelsRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
